const BaseView = require('./base');
const UploadListMixin = require('../../components/mixins/upload-list');
const CompanyFactory = require('../../../../factory/company').instance;

module.exports = BaseView.extend({
  allProjects: [],
  otherProjects: [],

  uploadConfig: {
    validation: {
      acceptFiles: '.jpg, .jpeg, .png, .pdf, .psd',
      allowedExtensions: ['jpg', 'jpeg', 'png', 'pdf', 'psd']
    },
    uploadSuccess: { params: { loadType: 120 } }
  },

  initialize: function (options) {
    this.deferred = $.Deferred();

    const mapOtherProjects = _.bind(function (data) {
      if (!data) { return; }

      this.otherProjects = _.sortBy(data, 'modified_date').reverse();
      this.otherProjects = _.without(_.pluck(this.otherProjects, 'id'), INKIVE.C.BOOK.id);
      this.allProjects = _.clone(this.otherProjects);

      this.deferred.resolve();
    }, this);

    if (INKIVE.Helpers.projectIsLinkedToRestrictions()) {
      const getOtherProjects = function (url) {
        CompanyFactory.get([url]).then(function (c) {
          const data = _.map(c, function (o) {
            return {
              id: o.encoded_id,
              modified_date: o.pages[0] ? o.pages[0].last_mod : null
            };
          });
          mapOtherProjects(data);
        });
      };

      if (INKIVE.C.BOOK.book_type === INKIVE.C.BOOK_TYPE.TEMPLATE) {
        INKIVE.FormatFactory.getCurrentFormat().then(function (f) {
          getOtherProjects('campaigns/' + f.campaign + '/templates');
        });
      } else {
        getOtherProjects('designs');
      }
    } else {
      INKIVE.Helpers.api('photo/saved', 'GET', {
        id: INKIVE.C.BOOK.id,
        type: 'albums'
      }, _.bind(function (r) {
        r && mapOtherProjects(r.data);
      }, this));
    }

    if (!options.premium) {
      this.uploadConfig.validation.acceptFiles = '.jpg, .jpeg, .png';
      this.uploadConfig.validation.allowedExtensions = ['jpg', 'jpeg', 'png'];
    }

    BaseView.prototype.initialize.call(this, options);

    options.premium || options.$uploadButton.siblings('input').css('height',
      options.$uploadButton.siblings('.drag-drop-file').css('height'));

    this.refreshView = _.debounce(_.bind(function () {
      this.masonryReload();

      this.from = 0;
      this.stopLoading = false;
      this.otherProjects = _.clone(this.allProjects);
      this.projectId = INKIVE.C.BOOK.id;
      this.$el.find('.thumbnail:not(.uploader)').remove();
      this.$el.find('.thumbnail-wrapper').height(40);
      INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));

      _.delay(_.bind(this.initDataLoading, this), 6000);
    }, this), 2000);
  },

  extractData: function (data) {
    return _.compact(_.map(data, function (item, i) {
      if (!item.thumb.url.trim()) return;
      const isAlreadyPresent = _.find(this.addedThumbnails, function (obj) {
        return obj.original.url === item.original.url;
      });
      if (isAlreadyPresent) return;

      this.addedThumbnails.push(item);

      const formatData = this.formatImageData(item);
      const imageData = this.getImageData(formatData);
      this.imagesFactory.addImageData(formatData);

      return {
        id: 'photo-saved-' + item.original.url.hashCode(),
        src: item.thumb.url,
        width: item.original.width,
        height: item.original.height,
        times_used: false/* item['count'] */,
        data: imageData,
        sticker_value: 0/* item['count'] */,
        sticker_tooltip: 'used ' + item.count + ' time' + (item.count > 1 ? 's' : '')
      };
    }, this));
  },

  complete: function (id, data) {
    if (data.photoId) {
      const $element = this.views[id].$el;
      const $item = $element.find('a');
      const tempLink = INKIVE.Helpers.getCORSSecureUrl(data.tempLink);
      UploadListMixin.complete.call(this, id, data);

      INKIVE.ImagesFactory.addImageData({ version: { original: tempLink } });

      this.tool.callbackImages($element, this.$el);
      this.$el.siblings('.section-title').css('visibility', '');

      $element.data('original-src', tempLink);
      $element.data('project-id', INKIVE.C.BOOK.id);

      $item.data('version', { original: tempLink, thumb: tempLink });
      $item.after(this.tool.getOverlayHtml($element, 'photo'));
      this.canvas.showOverlayElements();

      INKIVE.Helpers.initTooltips();
    } else {
      BaseView.prototype.complete.call(this, id, data);
    }
    this.setFileUploadButton();
  },

  errorEvent: function (event, id, fileName, message) {
    const isInvalidFileType = message && message.match('invalid extension');

    isInvalidFileType || BaseView.prototype.errorEvent.call(this, event, id, true);

    if (isInvalidFileType) {
      INKIVE.Modal.alertMessage(INKIVE.TemplatesHelper('alert_default', {
        message: 'modal.alert.upload_image_type_error',
        try_again: true
      }));
    }
    _.delay(_.bind(this.setFileUploadButton, this), 500);
  },

  appendThumbnails: function (result) {
    const callback = _.bind(this.tool.callbackImages, this.tool);
    const imagesToAdd = [];
    const imagesPresent = _.map(this.$el.find('img'), function (elem) {
      return $(elem).attr('data-original-src');
    });

    if (result) {
      for (const elem of result) {
        if (!imagesPresent.includes(elem.original.url) && elem.active !== false) {
          elem.db_url = elem.original.url;
          elem.original.url = INKIVE.Helpers.getCORSSecureUrl(elem.original.url);
          elem.original.src = INKIVE.Helpers.getCORSSecureUrl(elem.original.url);
          imagesPresent.push(elem.original.url);
          imagesToAdd.push(elem);
        }
      }
    }

    const uniqueImages = [];
    for (let i = 0; i < imagesToAdd.length; i++) {
      const itemI = imagesToAdd[i];
      if (i === imagesToAdd.length - 1) {
        uniqueImages.push(itemI);
        break;
      }
      let duplicated = false;
      for (let j = i + 1; j < imagesToAdd.length; j++) {
        const itemJ = imagesToAdd[j];
        if (itemI.active === itemJ.active && itemI.original.url === itemJ.original.url) {
          duplicated = true;
          break;
        }
      }
      !duplicated && uniqueImages.push(itemI);
    }

    this.tool.addThumbItem(this.$el, this.extractImageData(uniqueImages, INKIVE.C.BOOK.id), callback);

    this.$el.siblings('.section-title').css('visibility', '');
    this.masonryReload();
  },

  initScroll: function () {
    const $target = this.$el.parents('.add');
    const hasAntiscroll = $target.hasClass('antiscroll-wrap');

    hasAntiscroll || $target.addClass('antiscroll-wrap')
      .wrapInner('<div class="antiscroll-inner"></div>');

    $target.antiscroll({
      autoHide: false,
      width: $target.parents('.tab').width(),
      height: $target.height() || 40
    });
  },

  onMoreData: function (result) {
    result = Array.isArray(result) ? result : [];
    const hasResults = !!result.find(e => e.active);

    this.stopLoading = !this.$el.find('.loader-wrapper').isOnScreen();
    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    INKIVE.C.BOOK.id === result.project_id && this.addMissingProjectImages(result);
    hasResults && this.appendThumbnails(result);

    const projectId = this.otherProjects.shift();

    if (projectId) {
      this.projectId = projectId;
      this.from = 0;

      this.loadData(this.repeat, this.end);

      this.repeat();
    } else this.end();

    this.scrollRefresh();
  },

  loadData: function (repeat, end) {
    if (this.stopLoading) {
      this.$el.closest('.antiscroll-inner').off('scroll').on('scroll', event => {
        const $inner = $(event.target);
        const scrollHeight = $inner.get(0).scrollHeight;
        const scrollTop = $inner.get(0).scrollTop;
        const height = $inner.height();

        const per = Math.round((scrollTop + height) / scrollHeight * 100);
        if (per >= 99) {
          $inner.off();
          this._loadData(repeat, end);
        }
      });
    } else {
      this.deferred.then(() => this._loadData(repeat, end));
    }
  },

  _loadData: function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
    const endpoint = `business/projects/${this.projectId || INKIVE.C.BOOK.id}/images`;
    INKIVE.DesygnerApi.get(endpoint).then(this.onMoreData);
  },

  addMissingProjectImages: function (data) {
    const inlinedImages = _.unique(_.map(INKIVE.ImagesFactory.inlinedImages));

    _.each(inlinedImages, _.bind(function (url) {
      const isPresent = _.find(data, function (elem) {
        return url === elem.original.url;
      });

      isPresent || this.addToImportedImages(url);
    }, this));
  },

  addToImportedImages: function (url) {
    INKIVE.ImagesFactory.getImageOriginalSizeData(url, _.bind(function (image) {
      const data =
        {
          src: INKIVE.ImagesFactory.getAllImageVersions(url).thumb || url,
          original: url,
          project_id: INKIVE.C.BOOK.id,
          id: 'photo-' + _.random(99999999)
        };

      this.tool.addThumbItem(this.$el, data, _.bind(this.tool.callbackImages, this.tool));

      $.ajax({
        url: INKIVE.C.BASE_URL + 'api/photo/convertedphotos',
        type: 'POST',
        error: function (e) {
          console.error('Error processing' + url, e);
        },
        data: {
          project_id: INKIVE.C.BOOK.id,
          url: INKIVE.Helpers.getCORSSecureUrl(url),
          width: image.width,
          height: image.height
        }
      });
    }, this));
  },

  formatImageData: function (item) {
    return {
      image: {
        original: item.original.url,
        thumb: item.thumb.url,
        web: item.web.url,
        tab: item.tab.url,
        mobile: item.mobile.url,
        largeweb: item.largeweb.url,
        db_url: item.db_url,
        original_width: item.original.width,
        original_height: item.original.height
      }
    };
  },

  extractImageData: function (data, projectId) {
    return _.compact(_.map(data, function (item) {
      if (item.type === 'svg' || item.type === 'text' || !item.original) return;
      if (!item.thumb.url.trim()) return;

      const id = 'photo-saved-' + item.original.url.hashCode();
      if (this.$el.find('#' + id).length) return;

      const formatData = this.formatImageData(item);
      const imageData = this.getImageData(formatData);
      this.imagesFactory.addImageData(imageData);

      return {
        id,
        project_id: projectId,
        src: item.thumb.url,
        db_url: item.db_url,
        original: item.original.url,
        width: item.original.width,
        height: item.original.height,
        times_used: 0/* item['count'] */,
        data: imageData,
        sticker_value: false/* item['count'] */,
        sticker_tooltip: 'used ' + item.count + ' time' + (item.count > 1 ? 's' : '')
      };
    }, this));
  }
});
